import { useState, lazy, Suspense } from 'react';
import { AiFillCloseCircle } from 'react-icons/ai';
import { storage, NOTICE_BANNER_POPUP } from 'utils/global';
import { noticeBannerSetting } from 'utils/constants';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { loadable } from 'react-lazily/loadable';
const NoticeEmailModal = lazy(() => import('./NoticeEmailModal'));
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { ReactCarouselSlider } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});

interface Props {
	textPopupData: any;
	siteSettingData: any;
}

const NoticeBanner = ({ textPopupData, siteSettingData }: Props) => {
	const [selectedNotice, setSelectedNotice] = useState(false);
	const [lgShow, setLgShow] = useState(false);
	const [isOpen, setIsOpen] = useState<any>(storage.getSession(NOTICE_BANNER_POPUP) ? false : true);

	function handleClose() {
		setIsOpen(false);
		storage.setSession(NOTICE_BANNER_POPUP, false);
	}

	return (
		<>
			{siteSettingData?.select_popup === 'over_banner' && window.location.pathname != '/individual/support-individual/terms-conditions' && isOpen && textPopupData.length > 0 && (
				<div className="noticeBanner-wrapper">
					<div className="container position-relative">
						<ReactCarouselSlider {...noticeBannerSetting} className="pr-4">
							{textPopupData?.map((item, index) => (
								<h5 key={index} className="d-flex justify-content-between text-white mb-0 align-items-start align-items-md-center flex-column flex-md-row">
									<span>
										<TranslationMessage data={item} value="title" />
									</span>
									<div className="noticeBanner-linkWrapper">
										{item?.url.startsWith('https') || item?.url.startsWith('http') || item?.url.startsWith('www') ? (
											<a href={item.url} target="_blank">
												<FormattedMessage id="global.read-more" />
											</a>
										) : (
											<Link to={item.url}>
												<FormattedMessage id="global.read-more" />
											</Link>
										)}

										{/* <a
											role="button"
											className="px-2 auction-btn"
											onClick={() => {
												setSelectedNotice(item);
												setLgShow(true);
											}}
										>
											<FormattedMessage id="header.auction-hub" />
										</a> */}

										<a href="/auction" target="_blank" rel="noopener noreferrer" className="px-2 auction-btn">
											<FormattedMessage id="header.auction-hub" />
										</a>
									</div>
								</h5>
							))}
						</ReactCarouselSlider>

						<AiFillCloseCircle onClick={handleClose} role="button" className="text-white h4 notice-close-btn" />
					</div>
				</div>
			)}

			{/* email popup modal */}
			<Suspense fallback={<div>Loading...</div>}>
				<NoticeEmailModal lgShow={lgShow} setLgShow={setLgShow} selectedNotice={selectedNotice} />
			</Suspense>
		</>
	);
};

export default NoticeBanner;
